import { translateFr as tfr } from "@/i18n";
// Shared expiration-status logic for documents (KPI, filters, badges, dashboard)

export const DOC_TYPE_LABELS = {
  cv: "CV sportif",
  highlights: "Highlights",
  stats: "Statistiques",
  id: "Pièce d'identité",
  contract: tfr("Contrat"),
  scout: "Rapport scout",
  negotiation: tfr("Fiche de négociation"),
  career_plan: tfr("Plan de carrière"),
  other: "Autre",
};

const DOC_TYPE_LABELS_EN = {
  cv: "Sports CV", highlights: "Highlights", stats: "Statistics", id: "ID document",
  contract: "Contract", scout: "Scout report", negotiation: "Negotiation sheet",
  career_plan: "Career plan", other: "Other",
};

export function docTypeLabel(v) {
  try { if (localStorage.getItem("athlynx_lang") === "en") return DOC_TYPE_LABELS_EN[v] || DOC_TYPE_LABELS[v] || v; } catch { /* noop */ }
  return DOC_TYPE_LABELS[v] || v;
}

const _en = () => { try { return localStorage.getItem("athlynx_lang") === "en"; } catch { return false; } };

export const EXPIRY_FILTERS = [
  { v: "all", label: tfr("Tous"), label_en: "All" },
  { v: "expired", label: tfr("Expirés"), label_en: "Expired" },
  { v: "expiring", label: tfr("Expirent bientôt"), label_en: "Expiring soon" },
  { v: "valid", label: tfr("À jour"), label_en: "Up to date" },
  { v: "none", label: "Sans expiration", label_en: "No expiration" },
];

export function expiryFilterLabel(f) {
  return _en() ? f.label_en : f.label;
}

export function docSeverity(days) {
  const en = _en();
  if (days === null || days === undefined) return { cls: "bg-secondary text-muted-foreground border-border", label: "—" };
  if (days < 0) return { cls: "bg-danger/15 text-danger border-danger/40", label: en ? "Expired" : "Expiré" };
  const unit = en ? "d" : "j";
  if (days <= 3) return { cls: "bg-danger/15 text-danger border-danger/40", label: `${days} ${unit}` };
  if (days <= 7) return { cls: "bg-danger/10 text-danger border-danger/30", label: `${days} ${unit}` };
  if (days <= 14) return { cls: "bg-warning/15 text-warning border-warning/40", label: `${days} ${unit}` };
  if (days <= 30) return { cls: "bg-warning/10 text-warning border-warning/25", label: `${days} ${unit}` };
  return { cls: "bg-secondary text-muted-foreground border-border", label: `${days} ${unit}` };
}

export function docStatusBadge(status, days) {
  const en = _en();
  if (status === "expired") return { cls: "bg-danger/15 text-danger border-danger/40", label: en ? "Expired" : "Expiré" };
  if (status === "expiring") {
    const cls = days <= 7 ? "bg-danger/10 text-danger border-danger/30" : "bg-warning/15 text-warning border-warning/40";
    return { cls, label: en ? `Expires in ${days} d` : `Expire dans ${days} j` };
  }
  if (status === "valid") return { cls: "bg-success/10 text-success border-success/30", label: en ? "Up to date" : "À jour" };
  return { cls: "bg-secondary text-muted-foreground border-border", label: en ? "No expiration" : "Sans expiration" };
}

export function formatSize(bytes) {
  if (!bytes && bytes !== 0) return "";
  if (bytes < 1024) return `${bytes} o`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Ko`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} Mo`;
}
